import { Form, Button, Select, Input, Row } from 'antd';
import { useTheme } from 'contexts/theme';

const { Item } = Form;
const { Option } = Select;

export default function DealFilter({
    layout = 'vertical',
    onFilter,
}: {
    layout?: 'vertical' | 'inline' | 'horizontal';
    onFilter: any;
}) {
    const { dark } = useTheme();
    return (
        <Row gutter={[10, 10]}>
            <Form
                name="table-form"
                layout={layout}
                className={dark ? 'form-dark' : 'form-light'}
                onFinish={onFilter}
            >
                <Item name="dealId">
                    <Input placeholder="Deal Id" type="number" />
                </Item>
                <Item name="dealName">
                    <Input placeholder="Deal Name" type="text" />
                </Item>
                <Item name="dealOwner">
                    <Input placeholder="Deal Owner" type="text" />
                </Item>
                <Item name="companyId">
                    <Input placeholder="Company Id" type="text" />
                </Item>
                <Item name="companyCity">
                    <Input placeholder="City" type="text" />
                </Item>
                <Item name="companyZip">
                    <Input placeholder="Zip" type="text" />
                </Item>
                <Button type="primary" htmlType="submit">
                    Search
                </Button>
            </Form>
        </Row>
    );
}
